<div data-testid="zone-tile">
    <div class="zone__top border-zone cursor-pointer"
         (click)="setTemplate(tile)">
        <floating-subtitle class="zone__name zone__name--valve font-21"
                           [text]="zones.setTileName(tile.params.txtId, 2588)">
        </floating-subtitle>
        <div class="zone__set-temperature bg-gradient bg-gradient--zone font-24 ">
            <p class="zone__set-temp font-bold" data-testid="set-temp">
                {{ tile.params.setTemp * 10 | format:7 }}
            </p>
            <div class="zone__actuator" title="{{subtitle(1161)}}">
                <img class="zone__actuator-img"
                     ngSrc="/assets/img/zone_icons/actuators_open_white.svg"
                     width="40" height="40" alt=""/>
                <p class="zone__actuator-name font-15">
                    {{ tile.params.openingPercentage | format:8 }}
                </p>
            </div>
        </div>
    </div>

    <div class="zone__status cursor-pointer">
        <div class="gradient-zone zone__status-background"
             data-testid="animation"
             [ngClass]="{ 'zone__status--animated': tile.params.workingStatus }"
             (click)="setTemplate(tile)"
        ></div>
    </div>

    <div class="zone__content cursor-pointer" (click)="setTemplate(tile)">
        <div class="zone__content-icon">
            <icon [iconName]="'valve'"
                  data-testid="tile-icon-valve"
                  [iconSize]="views.isMobileView() ? 40 : 50"
                  [className]="'zone__icon zone__icon--white zone__icon--tile fill-icon-grey'">
            </icon>
            <icon [iconName]="'valve'"
                  data-testid="tile-icon-valve-mobile"
                  [iconSize]="views.isMobileView() ? 40 : 50"
                  [className]="'zone__icon zone__icon--dark fill-black fill-icon-grey'">
            </icon>
        </div>
        <div class="zone__current-temp"
            data-testid="tile-value">
            {{ tile.params.currentTemp | format:7 }}
        </div>
    </div>

    <div class="dropdown-list dropdown-list--grey"
         *ngIf="tile.isSystemTile
        ? zones.valveDropdown.showDropdownInfo && tile.id === zones.valveDropdown.systemTileId
        : zones.valveDropdown.showDropdownInfo"
         (click)="zones.showHideDropdownList(0)"
         [ngStyle]="{ bottom: zones.valveDropdown.position.bottom, top: zones.valveDropdown.position.top }">

        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(1040) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    {{ tile.params.returnTemp | format:7 }}
                </p>
            </div>
        </div>

        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(1161) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    {{ tile.params.openingPercentage | format:8 }}
                </p>
            </div>
        </div>

        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(464) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name"
                   *ngIf="tile.params.boilerProtection == 1">
                    {{ subtitle(3498) }}
                </p>
                <p class="dropdown-list__value-name"
                   *ngIf="tile.params.boilerProtection != 1">
                    {{ subtitle(922) }}
                </p>
            </div>
        </div>

        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(465) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name"
                   *ngIf="tile.params.returnProtection == 1">
                    {{ subtitle(3498) }}
                </p>
                <p class="dropdown-list__value-name"
                   *ngIf="tile.params.returnProtection != 1">
                    {{ subtitle(922) }}
                </p>
            </div>
        </div>

        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(1005) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    {{ tile.params.setTempCorrection | format:6 }}
                </p>
            </div>
        </div>

        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(585) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    {{ tile.params.valvePump == 0 ? subtitle(922) : subtitle(950) }}
                </p>
            </div>
        </div>

        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ subtitle(973) }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    {{ tile.params.valveNumber }}
                </p>
            </div>
        </div>
    </div>

    <div class="zone__footer bg-style">
        <div class="zone__icons">
            <div class="zone__footer-icon zone__footer-icon--relay-status">
                <div class="zone__img-wrapper zone__img-wrapper--tile border-light"
                     title="{{ subtitle(1040) }}">
                    <img class="zone__tile-img"
                         ngSrc="/assets/img/zone_icons/return_protection.svg"
                         width="25" height="25" alt=""/>
                    <p class="font-15" data-testid="return-protection">
                        {{ tile.params.returnTemp | format:7 }}
                    </p>
                </div>
            </div>
            <div class="zone__footer-icon zone__footer-icon--relay-status">
                <div class="zone__img-wrapper border-light"
                     title="{{ subtitle(1161) }}">
                    <img ngSrc="/assets/img/zone_icons/actuators_open_white.svg"
                         class="zone__img-wrapper--actuators-open"
                         width="25" height="25" alt=""/>
                    <p class="font-15" data-testid="opening-percentage">
                        {{ tile.params.openingPercentage | format:8 }}
                    </p>
                </div>
            </div>
        </div>

        <div class="zone__icons">
            <div class="zone__settings bg-input bg-input--primary cursor-pointer"
                 (click)="tile.isSystemTile
                ? zones.showHideDropdownList('valve', 'systemTile', tile.id)
                : zones.showHideDropdownList('valve')"
                 [ngClass]="{ 'bg-input--open': tile.isSystemTile
                    ? zones.valveDropdown.showDropdownInfo && tile.id === zones.valveDropdown.systemTileId
                    : zones.valveDropdown.showDropdownInfo,
                'bg-input--primary':  !( tile.isSystemTile
                    ? zones.valveDropdown.showDropdownInfo && tile.id === zones.valveDropdown.systemTileId
                    : zones.valveDropdown.showDropdownInfo) }">
                <icon [iconName]="'settings'"
                      data-testid="settings-icon"
                      [iconSize]="40"
                      [className]="'fill-icon fill-icon--white'">
                </icon>
            </div>
        </div>
    </div>

    <div class="zone__relay-status-mobile fill-style">
        <img class="zone__relay-status-img"
             ngSrc="/assets/img/zone_icons/sun_v1-1.svg"
             data-testid="relay-status-mobile-icon"
             [ngClass]="{ 'zone__relay-status-mobile--animated': tile.params.workingStatus }"
             width="25" height="25" alt=""/>
    </div>
</div>
